// extracted by mini-css-extract-plugin
module.exports = {"matchingContainer":"common_matchingContainer__2r5Zd","root":"common_root__14v9f","addNewItemButton":"common_addNewItemButton__2Qh5O"};